import React from 'react';
import ContentCardGrid from './ContentCardGrid';

const ContentCardGridWithProps = (props: any) => {
  return (
    <ContentCardGrid
      title={props.title}
      description={props.description}
      theme={props.theme}
      cards={props.cards}
    />
  );
};

export default ContentCardGridWithProps;
